import { Injectable, computed, signal } from '@angular/core';
import { hasSeenWelcomeTour, markWelcomeTourSeen } from './welcome-tour-features';

@Injectable({ providedIn: 'root' })
export class WelcomeTourSession {
  private readonly dismissed = signal(false);

  readonly pending = computed(() => !this.dismissed() && !hasSeenWelcomeTour());

  release(): void {
    markWelcomeTourSeen();
    this.dismissed.set(true);
  }
}
